import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IDiligencePricings } from "../interface/diligence/IDiligencePricings";
import { ITradePricing } from "../interface/trade/ITradePricing";
import { IMultiPriceCalculatorRequest } from '../interface/calculator/IMultiPriceCalculatorRequest';
import { IRecalculatePricingResponse } from '../interface/calculator/recalculatePrice/IRecalculatePricingResponse';
import { IPricingCalculatorRequest } from '../interface/calculator/IPricingCalculatorRequest';
import { IBaseResponse } from '../interface/IBaseResponse';
import { ICreateP2Request } from '../interface/ICreateP2Request';

enum TradePricingServiceEnum {
  getDiligencePricings = "/diligence/",
  getTradePriceHistory = "/history?id=",
  recalculatePricing = '/recalculate',
  createP2 = '/create-p2',
}

export default class TradePricingService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/pricing");
  }
  public diligence = async (tradeId: number): Promise<IDiligencePricings> => await this.GET(TradePricingServiceEnum.getDiligencePricings + tradeId);

  public getTradePriceHistory = async (tradeId: number): Promise<ITradePricing[]> => await this.GET(TradePricingServiceEnum.getTradePriceHistory + tradeId);
  public postRecalculatePricing = async (request: IPricingCalculatorRequest | IMultiPriceCalculatorRequest): Promise<IBaseResponse<IRecalculatePricingResponse>> =>
    await this.POST(TradePricingServiceEnum.recalculatePricing, request);
  public createP2 = async (request: ICreateP2Request, tradeId: number): Promise<IBaseResponse> =>
    await this.POST(`${TradePricingServiceEnum.createP2}/${tradeId}`, request);
}
